export default "__VITE_ASSET__DKgYb8oM__"